import {newAxios} from './index'

export const Req_GetPermissions = function (data) {
  return newAxios({
    url: '/getPermissions',
    data
  })()
}

export const Req_GetPermConfig = function (data) {
  return newAxios({
    url: `/i/tenant/system/permission/configuration`
  })()
}

//根据权限获取员工列表
export const Req_GetUserList = function(data) {
  return newAxios({
    url:`/i/tenant/user/permission/list/staffs`,
    data
  },'json')()
}


// WEBPACK FOOTER //
// ./src/request/permission.js